import React, {CSSProperties} from "react";
import {MdCheckbox} from 'core/components/fields/fields';
import {getLovItem, lovLabel, lovParam, lovValue} from 'core/form/formUtils';
import {DropTarget} from 'react-dnd';
import {grey200, white, yellow100, yellow300} from "material-ui/styles/colors";

import "core/security/component/securableBlocks.less";
import {action, ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {ISECURABLE, MODULE, PERMISSION, SECURABLE, SECURABLE_TYPE, TSECURABLE} from "core/metamodel/metaConstant";
import {SecurableDefinition, SecurableDefinitionModuleMap, SecurableDefinitionSecurableMap, SecurablePermission, SecurityRole} from "core/security/securityDomain";
import {observer} from "mobx-react";
import FlatButton from "material-ui/FlatButton";
import {createIfAbsent} from "core/common/utils/jsonUtils";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {SecurableDetailDrawer} from "core/security/component/SecurableDetailDrawer";
import mdEntityService from "core/metamodel/mdEntityService";
import securityService from "core/security/securityService";


const securableTarget = {
   drop(props, monitor, component) {
    console.log('dropped, props = %O, item = %O', props, monitor.getItem());

    const {securables, securityRoleObject, entities}: SecurablesAssignedProps = props;
    const {module, type, securable} = monitor.getItem();


    let securableDefinition: SecurableDefinition =  securables[module][securable];

     let newSp = new SecurablePermission({
       securityRole: securityRoleObject.createLov(),
       securable: {value: securable, label: lovLabel(entities.get("SECURABLE").getLovItem(securable))},
       module: module,
       type: type
     }).modifyPermissions(securableDefinition.availablePermissions);

     console.log('NEW SecurityPermission ', newSp);

     securityRoleObject.permissions.push(newSp);

    console.log('AFTER ', securityRoleObject);

    securityRoleObject.$dirty = true;
    return { target: 'SecurablesAssigned' };
  }
};

const _wrapperStyle = {margin: 20};

interface SecurablesAssignedProps {
  entities: ObservableMap<MdEntity>;
  securityRoleObject: SecurityRole;
  securables: SecurableDefinitionModuleMap;
  canDrop?: boolean;
  isOver?: boolean;
  connectDropTarget?: any;
}



const TH_STYLE: CSSProperties = {position: "sticky", top: 82, zIndex: 100, backgroundColor: white};
const TD_STYLE: CSSProperties = {paddingTop: 5, paddingBottom: 5};
const TD_STYLE_GREY: CSSProperties = {paddingTop: 5, paddingBottom: 5, backgroundColor: grey200};

@DropTarget("SECURABLE", securableTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop()
}))
@observer
export class SecurablesAssigned extends React.Component<SecurablesAssignedProps, undefined> {

  render() {
    let {entities, securityRoleObject, securables, canDrop, isOver, connectDropTarget} = this.props;

    const style: any = {minHeight: 400};

    const isActive = canDrop && isOver;

    if (isActive) {
      style.backgroundColor = yellow300;
    } else if (canDrop) {
      style.backgroundColor = yellow100;
    }

    let permissionKeys = Object.keys(PERMISSION);

    let permissionMap: Record<MODULE, SecurablePermission[]> = securityRoleObject.permissions.reduce( (acc, sp) => {
      createIfAbsent(acc, sp.module, (k) => []).push(sp);
      return acc;
    }, {} as any);

    return connectDropTarget(
      <div style={_wrapperStyle}>
        <table className="zz-simple-table" style={{position: "relative"}}>
          <thead>
          <tr>
            <th style={TH_STYLE}/>
            {permissionKeys.map( (p,i) => (<th key={i} style={TH_STYLE}>{p}</th>))}
            <th style={TH_STYLE}/>

          </tr>
          </thead>
          {
            Object.entries(permissionMap).map(([module, sps]) => {
              const moduleLov = getLovItem(entities.get('MODULE').lovItems, module);
              const securableDefinitionSecurableMap: SecurableDefinitionSecurableMap = securables[module];
              return (
              <tbody key={module}>
                <tr>
                  <td colSpan={permissionKeys.length + 2} style={{paddingTop: 10, paddingBottom: 10}}>
                    <div className="secu-module-header" style={{justifyContent: "center"}}>
                      <span className={lovParam(moduleLov, 'icon')}/>
                      <div className="text">{lovLabel(moduleLov)}</div>
                    </div>
                  </td>
                </tr>
                {
                  sps.map( (sp, index) => <SecurableAssignedRow key={sp.securable.value} index={index} securablePermission={sp} securableDefinitionSecurableMap={securableDefinitionSecurableMap} securityRole={securityRoleObject} />)
                }
              </tbody>
            )})
          }
        </table>
      </div>
    );
  }




}



interface SecurableAssignedRowProps {
  securablePermission: SecurablePermission;
  securableDefinitionSecurableMap: SecurableDefinitionSecurableMap;
  securityRole: SecurityRole;
  index: number;
}
interface SecurablesAssignedRowState {
  openDetailDrawer?: boolean;
}

@observer
class SecurableAssignedRow extends React.Component<SecurableAssignedRowProps, SecurablesAssignedRowState> {

  state = {
    openDetailDrawer: false,
  };

  render() {
    const {securableDefinitionSecurableMap, securablePermission, index, securityRole} = this.props;

    let securableDefinition: SecurableDefinition = securableDefinitionSecurableMap[lovValue(securablePermission.securable)];
    const availablePermissions: PERMISSION[]  = securableDefinition.availablePermissions;
    const securableConfig: ISECURABLE = SECURABLE[lovValue(securablePermission.securable)];
    return (

      (securableConfig && securableConfig.detailHeader) ? (
        <tr>
          <td style={TD_STYLE}>
            <FlatButton onClick={this.openDrawer.bind(this, securablePermission)} label={lovLabel(securablePermission.securable)}/>
            { this.state.openDetailDrawer &&
              <SecurableDetailDrawer entities={mdEntityService.entityMap} open={this.state.openDetailDrawer} securablePermission={securablePermission}
                                     securableDefinition={securableDefinition} securityRole={securityService.securityRoleObject} onRequestChange={this.handleDrawerRequestChange}/> }
          </td>
          <SecurableAssignedCellWithDetail permission={PERMISSION.Read} securablePermission={securablePermission} securableDefinition={securableDefinition}/>
          <SecurableAssignedCellWithDetail permission={PERMISSION.New} securablePermission={securablePermission} securableDefinition={securableDefinition}/>
          <SecurableAssignedCellWithDetail permission={PERMISSION.Update} securablePermission={securablePermission} securableDefinition={securableDefinition}/>
          <SecurableAssignedCellWithDetail permission={PERMISSION.Delete} securablePermission={securablePermission} securableDefinition={securableDefinition}/>
          <SecurableAssignedCellWithDetail permission={PERMISSION.Execute} securablePermission={securablePermission} securableDefinition={securableDefinition}/>
          <SecurableAssignedCellWithDetail permission={PERMISSION.Export} securablePermission={securablePermission} securableDefinition={securableDefinition}/>
          <SecurableAssignedCellWithDetail permission={PERMISSION.Import} securablePermission={securablePermission} securableDefinition={securableDefinition}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.PublicGrid} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.TenantGrid} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.TenantGroupGrid} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <td style={TD_STYLE}>
            <a className="font-button-link" onClick={this.onDeletePermission.bind(this, lovValue(securablePermission.securable))}>
              <span className="fa fa-trash"/>
            </a>
          </td>
        </tr>
      ) : (
        <tr>
          <td style={TD_STYLE}>{lovLabel(securablePermission.securable)}</td>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.Read} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission}  permission={PERMISSION.New} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.Update} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.Delete} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.Execute} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.Export} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.Import} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.PublicGrid} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.TenantGrid} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <SecurableAssignedCell securablePermission={securablePermission} permission={PERMISSION.TenantGroupGrid} index={index} availablePermissions={availablePermissions} securityRole={securityRole}/>
          <td style={TD_STYLE}>
            <a className="font-button-link" onClick={this.onDeletePermission.bind(this, lovValue(securablePermission.securable))}>
              <span className="fa fa-trash"/>
            </a>
          </td>
        </tr>
      )

    )
  }

  @action onDeletePermission(event) {
    console.log('onDeletePermission: ');
    let {securityRole, securablePermission} = this.props;
    let index = securityRole.permissions.findIndex(sp => lovValue(sp.securable) === lovValue(securablePermission.securable));
    securityRole.permissions.splice(index, 1);
    securityRole.$dirty = true;
  }

  @action openDrawer(sp: SecurablePermission) {
    console.log('openDrawer: ', sp);
    this.setState({openDetailDrawer: true});
  }

  handleDrawerRequestChange = (evt) => {
    this.setState({openDetailDrawer: false});
  };

}



interface SecurableAssignedCellProps {
   permission: PERMISSION
   index: number;
   availablePermissions: PERMISSION[];
   securablePermission: SecurablePermission;
   securityRole: SecurityRole;
}

@observer
class SecurableAssignedCell extends React.Component<SecurableAssignedCellProps, undefined> {
  render() {
    const {permission, index, securablePermission, availablePermissions} = this.props;
    let active = availablePermissions.includes(permission);
    const tdStyle = active ? TD_STYLE : TD_STYLE_GREY;
    return (
      <td style={tdStyle}>
        {
          active &&
          <MdCheckbox name={permission + index} checked={securablePermission.isPermission(permission)}
                      onCheck={this.onCheck}/>
        }
      </td>
    )
  }
  @action onCheck = (evt, checked) => {
    const {securablePermission, permission, securityRole} = this.props;
    console.log('onCheck checked: ' + checked);
    securablePermission.setPermission(permission, checked);
    securityRole.$dirty = true;
  };
}

const SecurableAssignedCellWithDetail = observer(({permission, securablePermission, securableDefinition}:
                                                    { permission: PERMISSION, securablePermission: SecurablePermission, securableDefinition: SecurableDefinition}) => {
  let active = securableDefinition.availablePermissions.includes(permission);
  let total = securableDefinition.detailPermissions.length;
  let checked = securablePermission.detailPermissions.values().filter(spd => spd.isPermission(permission)).length;
  let effectiveChecked = (securablePermission.isPermission(permission)) ? (total - checked) : checked;
  const tdStyle = active ? TD_STYLE : TD_STYLE_GREY;
  return (
    <td style={tdStyle}>
      { (active) && (effectiveChecked + "/" + total)}
    </td>
  );
});



// WEBPACK FOOTER //
// ./src/core/security/component/securableAssigned.tsx